module.exports = "/assets/data/5f57176d152da848e3c697ce921d687d-CB7.data.json";